import { localeStore } from 'src/mobx/localesStore';
import { formatPrice, getTranslate } from 'src/utils/formatter';
import { LineThrough } from 'src/view/components/LineThrough/LineThrough';
import { IProduct, IProductModifierOption } from 'src/types/products';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { cartStore } from 'src/mobx/cartStore';

interface IProps {
  option: IProductModifierOption;
  productQuantity: IProduct['quantity'];
}

const CartProductOption: React.FC<IProps> = observer(({ option, productQuantity }: IProps): JSX.Element => {
  const price = option.price * option.quantity * productQuantity;

  return (
    <div
      key={option.id}
      className={`mb-2 d-flex flex-row flex-sm-column align-items-center align-items-sm-start option ${
        option.error ? 'invalid' : ''
      }`}
    >
      <div className="d-flex flex-row align-items-center full-width justify-content-between justify-content-lg-start align-items-lg-baseline option-container">
        <div className="d-flex align-items-center flex-sm-row flex-lg-column align-items-lg-start option-name-container">
          <span className="d-flex flex-row align-items-center option-name">
            <p className="family-semibold text-md-size-14 text-size-16 color-darkgray mr-2">
              {getTranslate(option.name)}
            </p>
            {option.quantity && (option.quantity > 1 || !cartStore.isEditable) && (
              <p>
                <bdo
                  className="family-regular text-md-size-10 text-size-14 color-gray mr-3"
                  dir={localeStore.direction}
                >
                  {`x${option.quantity}`}
                </bdo>
              </p>
            )}
          </span>
          {option.taxable || option.error ? null : (
            <p className="family-regular text-md-size-10 text-size-12 color-gray mr-3 ml-2 ml-sm-0  text-nowrap">
              {localeStore.t('non_taxable')}
            </p>
          )}
        </div>
        {!option.error ? (
          <p className="family-regular text-md-size-10 text-size-14 color-gray d-flex text-nowrap option-price">
            {price > 0 && <span className="d-flex d-md-none">+</span>} {formatPrice(price)}
          </p>
        ) : null}

        {option.error ? <LineThrough /> : null}
      </div>
    </div>
  );
});

export default CartProductOption;
